import React from 'react';

import { BaseSvgIcon } from 'reactComponents/icons/_baseSvgIcon';

export const IconLock = ({
    width,
    height,
    className,
    onClick,
    tooltip,
    ...svgProps
}) => {
    return (
        <BaseSvgIcon
            width={width}
            height={height}
            tooltip={tooltip}
            className={className}
            onClick={onClick}
            pathD="M3,6.004 L3,5 C3,2.792 5.016,1 7.5,1 C9.984,1 12,2.792 12,5 L12,6.004 C12.56,6.05 13,6.479 13,7 L13,14 C13,14.552 12.507,15 11.9,15 L3.1,15 C2.493,15 2,14.552 2,14 L2,7 C2,6.479 2.44,6.05 3,6.004 L3,6.004 L3,6.004 Z M8.6,10 C8.6,9.448 8.107,9 7.5,9 C6.893,9 6.4,9.448 6.4,10 L6.4,11 C6.4,11.552 6.893,12 7.5,12 C8.107,12 8.6,11.552 8.6,11 L8.6,10 Z M10,6 L10,5 C10,3.896 8.742,3 7.5,3 C6.258,3 5,3.896 5,5 L5,6 L10,6 Z"
            {...svgProps}
        />
    );
};

export default IconLock;
